// WHY: kept dependency-free (no view imports) - organizer-formats-routes.ts pulls in every
// organizer view, so consumers importing route names from it created circular imports.
export const ORGANIZER_FORMAT_INSTITUTIONS_ROUTE = 'organizer-format-institutions' as const
